import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { StorageService } from './storage.service';
import { ObserverService } from './observer.service';
import { DatabaseService } from './database.service';
import { ConnectedAccountService } from './connected-account.service';
import * as moment from 'moment-timezone';
import { Decimal } from 'decimal.js';

@Injectable()
export class CashTrackingService {

    moment = moment;

    constructor(
        public alertController: AlertController,
        private observerService: ObserverService,
        private storageService: StorageService,
        private databaseService: DatabaseService,
        private connectedAccountService: ConnectedAccountService
    ) { }

    addCashMovement(raw_cash_movement) {
        return new Promise<void>((resolve, reject) => {
            this.storageService.get("connected_account_id").then((connected_account_id) => {
                if(connected_account_id) {
                    this.connectedAccountService.getConnectedAccount(connected_account_id).then((connected_account) => {
                        if(connected_account) {
                            let cash_movement = {};
                            cash_movement["user_id"] = connected_account['user_id'];
                            cash_movement["price"] = raw_cash_movement.price;
                            cash_movement["currency_id"] = raw_cash_movement.currency_id;
                            cash_movement['date'] = new Date();
                            if(raw_cash_movement['note']) {
                                cash_movement['note'] = raw_cash_movement['note'];
                            }
                            this.databaseService.cash_movement.add(cash_movement).then(() => {
                                this.observerService.publish("cash_movement_added", cash_movement);
                                resolve();
                            })
                            .catch(() => {
                                reject();
                            });
                        }
                        else {
                            reject();
                        }
                    })
                    .catch(() => {
                        reject();
                    });
                }
                else {
                    reject();
                }
            })
            .catch(() => {
                reject();
            });
        });
    }

    addCashTracking(cash_tracking_session_floats) {
        return new Promise((resolve, reject) => {
            if(cash_tracking_session_floats) {
                this.storageService.get("connected_account_id").then((connected_account_id) => {
                    if(connected_account_id) {
                        this.connectedAccountService.getConnectedAccount(connected_account_id).then((connected_account) => {
                            if(connected_account) {
                                let cash_tracking_session = {};
                                cash_tracking_session["floats"] = cash_tracking_session_floats;
                                cash_tracking_session["user_id"] = connected_account['user_id'];
                                cash_tracking_session["start_date"] = new Date();
                                this.storageService.set("cash_tracking_session", cash_tracking_session).then(() => {
                                    this.observerService.publish("cash_tracking_session_changed", cash_tracking_session);
                                    resolve(cash_tracking_session);
                                })
                                .catch(() => {
                                    reject();
                                });

                            }
                            else {
                                reject();
                            }
                        })
                        .catch(() => {
                            reject();
                        });
                    }
                    else {
                        reject();
                    }
                })
                .catch(() => {
                    reject();
                });
            }
            else {
                reject();
            }
        });
    }

    deleteCashTracking() {
        return new Promise<void>((resolve, reject) => {
            this.storageService.remove('cash_tracking_session').then(() => {
                this.databaseService.cash_movement.clear().then(() => {
                    this.observerService.publish("cash_tracking_session_deleted", (null));
                    resolve();
                })
                    .catch(() => {
                        reject();
                    });
            })
                .catch(() => {
                    reject();
                });
        });
    }

    getCashMovements() {
        return new Promise((resolve, reject) => {
            this.databaseService.cash_movement.toArray().then((cash_movements) => {
                resolve(cash_movements);
            })
            .catch(() => {
                reject();
            });
        });
    }

    getCashTrackingSession() {
        return new Promise((resolve, reject) => {
            this.storageService.get("cash_tracking_session").then((cash_tracking_session) => {
                if (cash_tracking_session) {
                    resolve(cash_tracking_session);
                }
                else {
                    resolve(null)
                }
            })
            .catch(() => {
                reject();
            });
        });
    }

}
